import { render, staticRenderFns } from "./UserTestReports.vue?vue&type=template&id=1ab61b00"
import script from "./UserTestReports.vue?vue&type=script&lang=js"
export * from "./UserTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports